var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import { number, arrayOf, array, string, shape } from 'prop-types';
import Cell from './cell';
import EmptyCell from './empty';
import Separator from './separator';
import { ELEMENT } from '../../../../data-parser/div-cards/const';
import * as CLS from './cls';

var Column = function (_PureComponent) {
    _inherits(Column, _PureComponent);

    function Column() {
        _classCallCheck(this, Column);

        return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
    }

    _createClass(Column, [{
        key: 'getCell',
        value: function getCell(row, rowIndex, colIndex) {
            var key = 'cell_' + rowIndex + '_' + colIndex;
            var height = this.props.layout[rowIndex];

            if (!row) {
                return React.createElement(EmptyCell, {
                    key: key,
                    height: height
                });
            }

            switch (row.type) {
                case ELEMENT.row:
                    return React.createElement(Cell, _extends({}, row.cells[colIndex], {
                        paddingBottom: row.bottomPadding,
                        paddingTop: row.topPadding,
                        height: height,
                        key: key
                    }));
                case ELEMENT.separator:
                    return React.createElement(Separator, { key: key });
                default:
                    return React.createElement(EmptyCell, {
                        key: key,
                        height: height
                    });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var props = this.props;
            var colIndex = props.colIndex;

            var mod = {
                paddingRight: props.rightPadding,
                paddingLeft: props.leftPadding
            };

            return React.createElement(
                'div',
                {
                    className: CLS.column(mod)(),
                    style: this.style
                },
                props.rows.map(function (row, rowIndex) {
                    return _this2.getCell(row, rowIndex, colIndex);
                })
            );
        }
    }, {
        key: 'style',
        get: function get() {
            var props = this.props;
            var weight = props.weight;


            return weight === 0 ? {
                flexShrink: 0,
                flexGrow: 0
            } : {
                flexShrink: 1,
                flexGrow: weight,
                width: 0
            };
        }
    }]);

    return Column;
}(PureComponent);

Column.propTypes = {
    weight: number,
    rows: arrayOf(shape({
        cells: array
    })),
    colIndex: number,
    layout: array,
    rightPadding: string,
    leftPadding: string
};
Column.defaultProps = {
    weight: 1,
    colIndex: 0,
    rows: [],
    layout: [],
    rightPadding: '',
    leftPadding: ''
};
export default Column;